import React from 'react';
import PropTypes from 'prop-types';
import { get, find, filter, head, isEmpty, map } from 'lodash';
import { fetchInventory, storeInventoryItem, deleteInventoryItem } from '../app-main/actions/inventory';
import { toggleModal } from '../app-main/actions/modal';
import { toggleBanner } from '../app-main/actions/banner';
import { fetchAllFeeProfiles } from '../app-main/actions/fee-profile';
import { fetchRegionalFees } from '../app-main/actions/fees';
import { collectVatCopy, addOnTaxTypeOptions } from './utils';

const ManageAddonsHoc = (Component) => {
  class hoc extends React.Component {
    constructor (props) {
      super(props);

      this.state = {
        isCanada: false,
        feeProfile: {}
      };

      this.toggleModal = this.toggleModal.bind(this);
      this.openEditAddonModal = this.openEditAddonModal.bind(this);
      this.deleteItem = this.deleteItem.bind(this);
    }

    componentDidMount () {
      const { dispatch, env, auth, SSOid } = this.props;
      const token = get(auth, 'accessToken', '');
      const isVatEnabled = get(env, 'web.is_vat_enabled');

      if (isVatEnabled) {
        dispatch(fetchAllFeeProfiles(token, SSOid)).then(profiles => {
          const feeProfiles = get(this.props, 'fee_profiles', {});
          const vatAddresses = get(feeProfiles, 'vatAddress', []);
          let vatProfile = {}

          // only need sub region VAT profile since country will be the same as the
          // federal level VAT profile. Only difference is "state"
          if (vatAddresses.length > 1) {
            vatProfile = head(filter(vatAddresses, ['is_subregion', true]));
          } else {
            vatProfile = get(vatAddresses, '[0]', {});
          }

          const billingAddress = get(feeProfiles, 'billingAddress.data[0]');
          const feeProfile = !isEmpty(vatProfile) ? vatProfile : billingAddress;
          const isCanada = 'CA' === get(feeProfile, 'country');


          this.setState({
            isCanada,
            feeProfile
          });

          const getRegionalFeesPayload = {
            country: get(feeProfile, 'country'),
            ...(isCanada && { state: get(feeProfile, 'state') })
          };

          dispatch(fetchRegionalFees(token, getRegionalFeesPayload))
        })
      }
    }

    openEditAddonModal (item) {
      this.props.dispatch(storeInventoryItem(item));
      this.toggleModal('editAddOnModal');
    }

    deleteItem () {
      const itemId = get(this.props, 'inventory.item._id');
      const spaceId = get(this.props, 'inventory.item.space_id');
      const token = get(this.props, 'auth.accessToken');

      this.props.dispatch(deleteInventoryItem(itemId, token))
        .then(() => this.props.dispatch(fetchInventory(spaceId, token)))
        .then(() => {
          this.toggleModal();
          return this.props.dispatch(toggleBanner('addonsDeleteSuccess'));
        })
        .catch(() => {
          this.toggleModal();
          return this.props.dispatch(toggleBanner('addonsDeleteError'));
        });
    }

    toggleModal (modalId, modalData) {
      this.props.dispatch(toggleModal({ modalId, modalData }));
    }


    render () {
      return (
        <Component
          {...this.props}
          toggleModal={this.toggleModal}
          openEditAddonModal={this.openEditAddonModal}
          deleteItem={this.deleteItem}
        />
      );
    }
  }

  hoc.propTypes = {
    dispatch: PropTypes.func.isRequired,
    inventory: PropTypes.object,
    feeTypes: PropTypes.array,
    fees: PropTypes.object,
    isVatEnabled: PropTypes.bool
  };

  return hoc;
};

export default ManageAddonsHoc;
